import { SVGProps } from 'react'

const SvgDeviceFaultEvent = (props: SVGProps<SVGSVGElement>) => (
  <svg fill='none' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M12 2a1 1 0 0 0-1 1v1H8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3v5a1 1 0 1 0 2 0v-5h3a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-3V3a1 1 0 0 0-1-1zm0 4.875c.168 0 .337.083.434.25l3.03 5.25a.5.5 0 0 1-.433.75H8.97a.5.5 0 0 1-.432-.75l3.031-5.25a.493.493 0 0 1 .432-.25zM12 8a.5.5 0 0 0-.5.5V10a.5.5 0 0 0 1 0V8.5A.5.5 0 0 0 12 8zm-.025 3A.501.501 0 1 0 12 11h-.025z' />
  </svg>
)

export default SvgDeviceFaultEvent
